import React from 'react'
import PropTypes from 'prop-types'
import * as Component from './ChipList.styles'

const ChipList = (props) => {
  const { children, chipListId } = props

  return <Component.Container id={ chipListId }>{children}</Component.Container>
}

ChipList.propTypes = {
  /** Children Chips */
  children: PropTypes.node.isRequired,
  /** Unique Identifier  */
  chipListId: PropTypes.string.isRequired,
}

export default ChipList
